import { Box, Typography } from "@mui/material";
import AppButton from "../../../../base/AppButton.component";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import Theme from "../../../../../utils/Theme";

// Same breakpoint used across the artifact screen (ArtifactStyle,
// WarrantyStartPopup, ToggleComponent) so pagination shrinks in step with
// everything else on short-height landscape phones.
const LANDSCAPE_SHORT = "@media (orientation: landscape) and (max-height: 500px)";

const PaginationComponent = (props) => {
  const { handlePrevious, currentIndex, totalPages, handleNext } = props;

  // Theme.palette.grey is an object ({50,100,...900}), not a color string.
  // Use a real hex value or Theme.palette.grey[500] if you add a custom grey scale.
  const disabledColor = "#9e9e9e";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        alignItems: "center",
        gap: "10px",
        py: "8px", // fixed padding instead of mobile-only bottom margin —
                   // safe-area spacing is now handled by ArtifactStyle.paginationZone
        [LANDSCAPE_SHORT]: {
          gap: "6px",
          py: "2px",
        },
      }}
    >
      <AppButton
        buttonText={"PREV"}
        variant={"text"}
        clickHandler={handlePrevious}
        startIcon={<ArrowBack sx={{ fontSize: "20px", [LANDSCAPE_SHORT]: { fontSize: "14px" } }} />}
        disabled={currentIndex + 1 === 1}
        sx={{
          color:
            currentIndex + 1 === 1
              ? disabledColor
              : Theme.palette.primary.main,
          fontSize: "20px",
          [LANDSCAPE_SHORT]: { fontSize: "13px", minWidth: "auto", px: "6px" },
        }}
      />
      <Typography
        variant="body"
        sx={{
          fontSize: "20px",
          [LANDSCAPE_SHORT]: { fontSize: "13px" },
        }}
      >
        {currentIndex + 1} of {totalPages}
      </Typography>
      <AppButton
        buttonText={"NEXT"}
        variant={"text"}
        clickHandler={handleNext}
        disabled={currentIndex + 1 === totalPages}
        endIcon={<ArrowForward sx={{ fontSize: "20px", [LANDSCAPE_SHORT]: { fontSize: "14px" } }} />}
        sx={{
          color:
            currentIndex + 1 === totalPages
              ? disabledColor
              : Theme.palette.primary.main,
          fontSize: "20px",
          [LANDSCAPE_SHORT]: { fontSize: "13px", minWidth: "auto", px: "6px" },
        }}
      />
    </Box>
  );
};

export default PaginationComponent;